import { useParams, useNavigate } from "react-router-dom";
import { EditInvoicePage as EditInvoicePageView } from "@/components/EditInvoicePage";

export function EditInvoicePage() {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const navigate = useNavigate();

  if (!invoiceId) return null;

  return (
    <EditInvoicePageView
      invoiceId={invoiceId}
      onSaved={(id) => navigate(`/invoices/${id}`)}
      onCancel={() => navigate(`/invoices/${invoiceId}`)}
    />
  );
}
